import { AiOutlineCloseCircle } from "react-icons/ai";
import { useSeller } from "../../../context/seller";
import Modal from "../../common/Modal";
import { useEffect, useState } from "react";
import { ReservationPayment } from "../../../types/common.types";
import SellerService from "../../../services/seller.service";
import styled from "styled-components";
import format from "date-fns/format";
import removeTimezone from "../../../utils/removeTimezone";

export default function ViewPayments() {
    const { viewPaymentsData, setViewPaymentsData, setIsCreatePaymentModalOpen } = useSeller()

    return (
        <Modal>
            <h1>View Payments</h1>
            <div className="actions"
            >
                <button
                type="button"
                onClick={() => setIsCreatePaymentModalOpen(true)}
                style={{float: 'initial'}}
                >
                    Create
                </button>
            </div>
                <TableWrapper>
                        <Table>
                            <thead>
                                <th>Amount</th>
                                <th>Amount tickets</th>
                                <th>Payment Date</th>
                                <th>Authorized</th>
                                <th>Pic</th>
                                <th>Remarks</th>
                            </thead>
                            <tbody>
                                {
                                    viewPaymentsData!.map(payment => {
                                            return <tr key={payment.id}>
                                                <td>{payment.amount || 0}</td>
                                                <td>{payment.amount_tickets || 0}</td>
                                                <td>{removeTimezone(payment.created_at.toString())}</td>
                                                <td>{payment.authorized ? 'Yes' : 'No'}</td>
                                                <td>
                                                    <div className="img">
                                                        {
                                                            payment.pic ?
                                                            <>
                                                            <img src={`${process.env.REACT_APP_API_URL}/files/${payment.pic}`} alt="payment pic" />
                                                            <a target="_BLANK" href={`${process.env.REACT_APP_API_URL}/files/${payment.pic}`}></a>
                                                            </>
                                                            :
                                                            <>No image attached</>
                                                        }
                                                    </div>
                                                </td>
                                                <td>{payment.remarks}</td>
                                            </tr>
                                    })
                                }
                                </tbody>
                        </Table>
                </TableWrapper>
            <div className="close"
            onClick={() => setViewPaymentsData(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
table-layout: fixed;
height: 100%;
position: relative;
width: 100%;
min-width: 400px;
overflow: hidden;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    height: 100px;
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        width: 25px;
        height: 25px;
        border-radius: 5px;
        border: none;
        background-color: ${props => props.theme.blueLight};
        color: ${props => props.theme.white};
        cursor: pointer;
    }
    .img {
        width: 100%;
        position: relative;
        img {
            width: 100%;
        }
        a {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            z-index: 10;
            top: 0;
            left: 0;
        }
        padding: 10px;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`